// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"08453e51","127":"cbcff39b","159":"bf5fbb7b","217":"701c1f91","399":"2b4fd415","435":"c0ca695a","443":"93af0a6b","577":"6693cfa1","610":"85327703","640":"d617a7a4","852":"0f888fe3","902":"1660efd1"}[chunkId] + ".chunk.js";
};